;(function (root, factory) {
  if (typeof exports === 'object') {
    module.exports = factory();
  } else if (typeof define === 'function' && define.amd) {
    define('Typing', [], function ($) {
      return (root.Typing = factory($));
    });
  } else {
    root.Typing = factory();
  }
}(this, function() {
  function Typing (opts) {
    this.opts = opts || {};
    this.source = opts.source;
    this.output = opts.output;
    this.delay = opts.delay || 120;
    this.chain = {
      parent: null,
      dom: this.output,
      val: []
    };
    this._stop = true;
    this._timer = null;
    this._pending = null;
    this._complete = false;
    this._destroyed = false;

    if (!(typeof this.opts.done == 'function')) this.opts.done = function() {};
  }

  Typing.fn = Typing.prototype = {
    toArray: function (eles) {
      var result = [];
      for (var i = 0; i < eles.length; i++) {
        result.push(eles[i]);
      }
      return result;
    },

    init: function () {
      this.chain.val = this.convert(this.source, this.chain.val);
    },

    convert: function (dom, arr) {
      var that = this,
          children = this.toArray(dom.childNodes);

      for (var i = 0; i < children.length; i++) {
        var node = children[i];
        if (node.nodeType === 3) {
          arr = arr.concat(node.nodeValue.split(''));
        } else if (node.nodeType === 1) {
          var val = [];
          val = that.convert(node, val);
          arr.push({
            'dom': node,
            'val': val
          });
        }
      }

      return arr;
    },

    print: function (dom, val, callback) {
      var that = this;
      this._timer = setTimeout(function(){
        that._timer = null;
        if (that._destroyed) return;
        if (that._stop) {
          that._pending = function() {
            that.print(dom, val, callback);
          };
          return;
        }
        dom.appendChild(document.createTextNode(val));
        callback();
      }, this.delay);
    },

    play: function (ele) {
      if (this._stop) return;
      if (!ele) return;
      if (!ele.val.length) {
        if (ele.parent) this.play(ele.parent);
        else {
          this._complete = true;
          this.opts.done();
        }
        return;
      }

      var curr = ele.val.shift();
      var that = this;

      if (typeof curr === 'string') {
        this.print(ele.dom, curr, function() {
          that.play(ele);
        });
      } else {
        var dom = document.createElement(curr.dom.nodeName);
        var attrs = that.toArray(curr.dom.attributes);
        for (var i = 0; i < attrs.length; i++) {
          var attr = attrs[i];
          dom.setAttribute(attr.name, attr.value);
        }
        ele.dom.appendChild(dom);
        curr.parent = ele;
        curr.dom = dom;
        this.play(curr.val.length ? curr : curr.parent);
      }
    },

    start: function () {
      if (this._destroyed) return;
      this._stop = false;
      this._complete = false;
      this.init();
      this.play(this.chain);
    },

    pause: function() {
      this._stop = true;
    },

    resume: function(){
      if (this._destroyed || this._complete || !this._stop) return;
      this._stop = false;
      if (this._timer) return;
      if (this._pending) {
        var pending = this._pending;
        this._pending = null;
        pending();
      } else {
        this.play(this.chain);
      }
    },

    destroy: function() {
      this._destroyed = true;
      this._stop = true;
      this._pending = null;
      if (this._timer) {
        clearTimeout(this._timer);
        this._timer = null;
      }
    }
  };

  Typing.version = '2.1';

  return Typing;
}));
